/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "संपूर्ण संग्रह",
  "tagline": "",
  "favicon": "img/favicon.ico",
  "url": "https://sangrah.justinclicks.com",
  "baseUrl": "/",
  "organizationName": "kaustubhk24",
  "projectName": "sangrah",
  "trailingSlash": false,
  "onBrokenLinks": "throw",
  "onBrokenAnchors": "ignore",
  "i18n": {
    "defaultLocale": "mr",
    "locales": [
      "mr"
    ],
    "localeConfigs": {
      "mr": {
        "label": "देवनागरी",
        "direction": "ltr",
        "htmlLang": "mr-IN",
        "path": "mr"
      }
    },
    "path": "i18n"
  },
  "presets": [
    [
      "classic",
      {
        "docs": {
          "sidebarPath": "/home/runner/work/sangrah/sangrah/sidebars.js",
          "routeBasePath": "/"
        },
        "sitemap": {
          "changefreq": "weekly",
          "priority": 0.7
        },
        "theme": {
          "customCss": "/home/runner/work/sangrah/sangrah/src/css/custom.css"
        }
      }
    ]
  ],
  "plugins": [
    null,
    [
      "@docusaurus/plugin-google-gtag",
      {
        "trackingID": "G-BDZNJ51SEP",
        "anonymizeIP": true
      }
    ],
    [
      "@docusaurus/plugin-pwa",
      {
        "debug": false,
        "offlineModeActivationStrategies": [
          "appInstalled"
        ],
        "swCustom": "/home/runner/work/sangrah/sangrah/src/sw.js",
        "injectManifestConfig": {
          "manifestTransforms": [
            null
          ],
          "globIgnores": [
            "**/*.mp3",
            "**/*.ogg",
            "**/*.wav",
            "**/search-index.json",
            "**/*.json"
          ],
          "maximumFileSizeToCacheInBytes": 52428800
        },
        "pwaHead": [
          {
            "tagName": "link",
            "rel": "manifest",
            "href": "/manifest.json"
          },
          {
            "tagName": "meta",
            "name": "theme-color",
            "content": "#bf43bb"
          },
          {
            "tagName": "meta",
            "name": "apple-mobile-web-app-capable",
            "content": "yes"
          },
          {
            "tagName": "meta",
            "name": "apple-mobile-web-app-status-bar-style",
            "content": "#bf43bb"
          }
        ]
      }
    ],
    null
  ],
  "themeConfig": {
    "image": "img/docusaurus-social-card.png",
    "announcementBar": {
      "id": "feedback_required",
      "content": "कृपया आपला <b><a target =\"_blank\" href=\"https://forms.gle/MPuDTkCpVTDpaoQG9\">अभिप्राय द्या.</a></b>",
      "backgroundColor": "#FFF4E5",
      "textColor": "#C75D00",
      "isCloseable": true
    },
    "navbar": {
      "style": "primary",
      "title": "संपूर्ण संग्रह",
      "logo": {
        "alt": "संपूर्ण संग्रह",
        "src": "img/favicon.ico"
      },
      "items": [
        {
          "to": "/search",
          "label": "शोधा",
          "position": "right"
        },
        {
          "to": "/bookmarks",
          "label": "चिन्हांकित पाने",
          "position": "right"
        },
        {
          "to": "/history",
          "label": "इतिहास",
          "position": "right"
        },
        {
          "to": "/counter",
          "label": "जप",
          "position": "right"
        },
        {
          "to": "/panchang",
          "label": "पंचांग",
          "position": "right"
        },
        {
          "to": "/muhurt",
          "label": "मुहूर्त",
          "position": "right"
        },
        {
          "to": "/project-information",
          "label": "प्रकल्प माहिती",
          "position": "right"
        },
        {
          "to": "/updates",
          "label": "अपडेट्स",
          "position": "right"
        }
      ],
      "hideOnScroll": false
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": true,
      "respectPrefersColorScheme": false
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "storage": {
    "type": "localStorage",
    "namespace": false
  },
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": false,
      "useCssCascadeLayers": false,
      "siteStorageNamespacing": false,
      "fasterByDefault": false,
      "mdx1CompatDisabledByDefault": false
    },
    "faster": {
      "swcJsLoader": false,
      "swcJsMinimizer": false,
      "swcHtmlMinimizer": false,
      "lightningCssMinimizer": false,
      "mdxCrossCompilerCache": false,
      "rspackBundler": false,
      "rspackPersistentCache": false,
      "ssgWorkerThreads": false,
      "gitEagerVcs": false
    },
    "experimental_vcs": {},
    "experimental_router": "browser"
  },
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "themes": [],
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    },
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    }
  }
};
